export default __webpack_public_path__ + "static/media/lift.ec35958d.JPG";